import { compact, flatMap, forEach } from 'lodash-es';
import {
  BUSINESS_TYPE_GAME,
  BUSINESS_TYPE_MYDASHBOARD,
  FOLDER_NAME_FAVORITES,
  MENU_CONTROL_PERMISSION,
} from '@/pages/dashboard/_config/constant';

/** 经分游戏（挂载表单只取有管理员权限的项） */
export type IDashboardGame = {
  game_code: string;
  game_name: string;
  game_cn_name?: string;
  studio?: string;
  role_type?: string;
  third_party_game?: string;
  role_id?: string;
  is_access?: boolean;
  game_List?: IDashboardGame[];
};

/** 经分菜单 / 目录节点 */
export type IMenuNode = {
  id: string;
  parent_id: string;
  name_en?: string;
  name_cn?: string;
  business_type?: string;
};

/**
 * 展平经分游戏列表（两层：main_game → game_List 子版本）
 * 只保留有系统/游戏管理员权限的游戏（sys_admin / game_manager）
 * 注：game_phase_list 是阶段元数据，不是子游戏列表
 * @param mainGame - userMessage.main_game
 * @returns 可挂载的游戏列表
 * @example flattenAdminGames([{ game_code: 'host', game_List: [{ game_code: 'x', role_id: 'sys_admin', is_access: true }] }])
 */
export const flattenAdminGames = (
  mainGame: IDashboardGame[] | undefined,
): IDashboardGame[] =>
  compact(
    flatMap(mainGame || [], (game) => {
      const versions = game.game_List?.length ? game.game_List : [game];
      return versions.map((item) =>
        item?.is_access &&
        MENU_CONTROL_PERMISSION.includes(item.role_id || '')
          ? item
          : undefined,
      );
    }),
  );

/**
 * 把 listMenu 的树拆成菜单 / 目录 / 子目录
 * 一期排除框架/基础报表：business_type === game（对齐 datalab，不按 name）
 * @param menuList - listMenu 返回的 menu_list
 * @returns 扁平后的三类列表
 */
export const parseMenuTree = (
  menuList: Array<Record<string, unknown>> | undefined,
): {
  menuList: IMenuNode[];
  folderList: IMenuNode[];
  subFolderList: IMenuNode[];
} => {
  const menus: IMenuNode[] = [];
  const folders: IMenuNode[] = [];
  const subFolders: IMenuNode[] = [];

  forEach(menuList || [], (menu) => {
    // 基础报表 / 框架报表：business_type = game，不按 name_en/name_cn 判断
    if (String(menu.business_type || '') === BUSINESS_TYPE_GAME) {
      return;
    }
    menus.push({
      ...menu,
      id: String(menu.u_id || ''),
      parent_id: String(menu.u_parent_id || ''),
    });
    forEach(
      (menu.folder_list as Array<Record<string, unknown>>) || [],
      (folder) => {
        const businessType = String(folder.business_type || '');
        const nameEn = String(folder.name_en || '');
        if (
          !(
            businessType === BUSINESS_TYPE_MYDASHBOARD &&
            nameEn === FOLDER_NAME_FAVORITES
          )
        ) {
          folders.push({
            ...folder,
            id: String(folder.u_id || ''),
            parent_id: String(folder.u_parent_id || ''),
          });
        }
        forEach(
          (folder.dashoboard_list as Array<Record<string, unknown>>) || [],
          (item) => {
            if (String(item.menu_type) === '3') {
              subFolders.push({
                ...item,
                id: String(item.u_id || ''),
                parent_id: String(item.u_parent_id || ''),
              });
            }
          },
        );
      },
    );
  });

  return { menuList: menus, folderList: folders, subFolderList: subFolders };
};
